/**
 * Created by yougen on 1/25/16.
 */
module.exports = require('./src/js/pre-inquiry/pre-inquiry.js');
